module.exports = __webpack_public_path__ + "img/accept_blue.f3190ad5.svg";